import React, { useState, useEffect } from 'react';
import { Row, } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SidebarData } from './Data';
//import { Auth } from 'aws-amplify';
import { getCurrentUser } from 'aws-amplify/auth';

function Menu() {
    const [menu, setMenu] = useState([]);
    useEffect(() => {
        checkUserdata();
    }, []);

    async function checkUserdata() {
        const user = await getCurrentUser();//await Auth.currentAuthenticatedUser()
        const menuData = await SidebarData(user.username.toUpperCase());
        setMenu(menuData);

    }
    return (
        <>
            <Row className="mt-4">
                {menu.map(menud => (
                    menud.mostrar === true && (
                        <>
                            <div className=" col-lg-4 col-md-6 col-sm-12 margintop20px">
                                <h3><Link to={menud.path}>
                                    {menud.icon}
                                </Link></h3>
                                <h4>{menud.title}</h4>
                            </div>
                        </>
                    )
                )
                )
                }
            </Row>
        </>
    )
}

export default Menu
